import React from 'react';
import { Badge } from 'components/common';

const STATUS_VARIANTS = {
  'Submitted': 'default',
  'In progress': 'warning',
  'Rejected': 'danger',
  'Completed': 'success',
};

const StatusRenderer = (props) => {
  const { value, data = {} } = props || {};
  const { status } = data;
  const variant = STATUS_VARIANTS[status] || 'default';

  return (
    <div className="tw-text-xs">
      <Badge variant={variant} size="sm" className="tw-mr-2">{value}</Badge>
    </div>
  );
};

export default StatusRenderer;
